import React from "react";
import successLogo from "assets/validationSuccess.png";
import { Modal } from "@mui/material";

const SuccessModal = (props) => {
  return (
    <Modal onClose={props.onClose} open={true}>
      <div className="success-modal">
        <img
          src={successLogo}
          alt="SUCCESS"
          className="sum-icon"
          width={50}
          height={50}
        />
        <div className="sum-title">SUCCESS</div>
        <button className="sum-btn" onClick={props.onClose}>
          Continue
        </button>
      </div>
    </Modal>
  );
};

export default SuccessModal;
